import Model from "./Model";
import Patient from './Patient';
import Practitioner from "./Practitioner";
import Establishment from './Establishment';
import { ClassTransformOptions, plainToClass, Type } from "class-transformer";
import InvoiceStatus from '../enums/InvoiceStatus';
import PaymentMethod from '../enums/PaymentMethod';
import Treatment from './Treatment';
import { route } from '../support/helpers';

class Invoice extends Model {
    id: number;
    practitioner_id: number;
    establishment_id: number;
    patient_id: number;
    reference: number;
    total:  number;
    @Type(() => Date)
    due_date:  Date;
    @Type(() => Date)
    payment_date: Date;
    payment_method: PaymentMethod;
    status: InvoiceStatus;
    @Type(() => Date)
    created_at: Date;
    @Type(() => Date)
    updated_at: Date;

    /*
    |--------------------------------------------------------------------------
    | Reflection
    |--------------------------------------------------------------------------
    */

    /**
     * Gets class name
     * survives minification/uglification
     *
     * @return {string}
     */
    getClassName(): string {
        return 'Invoice';
    }

    /*
    |--------------------------------------------------------------------------
    | Relationships
    |--------------------------------------------------------------------------
    */

    @Type(() => Practitioner)
    practitioner: Practitioner;

    @Type(() => Establishment)
    establishment: Establishment;

    @Type(() => Patient)
    patient: Patient;

    @Type(() => Treatment)
    treatments: Treatment[];

    /*
    |--------------------------------------------------------------------------
    | Methods
    |--------------------------------------------------------------------------
    */

    /**
     * Get created at
     *
     * @param {string} [format]
     * @return {string}
     */
    paymentDate(format?: string): string {
        return window.moment(this.payment_date).format(format || window.moment.HTML5_FMT.DATE);
    }

    /**
     * Download link.
     *
     * @returns {string}
     */
    downloadLink(): string {
        return route('practitioner.invoices.download', this.id);
    }

    /**
     * Payment method.
     *
     * @returns {string}
     */
    paymentMethod(): string {
        const trans = {
            'cash'         : 'Espéce',
            'check'        : 'Chéque',
            'credit_card'  : 'Carte bancaire',
            'bank_transfer': 'Virement bancaire'
        };

        return trans[this.payment_method];
    }

    /**
     * Converts plain (literal) object to class (constructor) object. Also works with arrays.
     */
    static new(plain: [], options?: ClassTransformOptions): Invoice[];
    static new(plain: {}, options?: ClassTransformOptions): Invoice;
    static new(plain: {} | [], options?: ClassTransformOptions): Invoice | Invoice[] {
        return plainToClass(Invoice, plain as any, options);
    }
}

export default Invoice;
